import { AnalyticsEvent } from './../models/analytics-event';
import { Injectable } from '@angular/core';
import { AnalyticsProvider } from './analytics-provider.interface';

declare global {
    interface Window { gtag: (...args: any[]) => void; }
}

@Injectable()
export class GA4Provider implements AnalyticsProvider {

    dispatch(event: AnalyticsEvent, payload?: any): void {
        if (!window.gtag) return;
        window.gtag('event', event, payload || {});
    }

}
